export const getAllTeams = ({ username, ownedTeams }) => {
    if (!ownedTeams || !username) {
        return null;
    }

    let allTeamOptions = [];

    const user = {
        option: username,
        slug: username // todo- change when we know what to mutate
    };

    ownedTeams.map(team => {
        // reassign "name" of team to "option" key:
        allTeamOptions.push({
            option: team.name,
            slug: team.username
        });
    });

    allTeamOptions.unshift(user); // push current user object to top of array

    return allTeamOptions;
};
